import React from 'react';
const points = [{
  emoji: '😰',
  text: 'Llegas a clase sin saber exactamente qué dar'
}, {
  emoji: '⏱️',
  text: 'Tardas horas planificando lo que podrías resolver en minutos'
}, {
  emoji: '🤷',
  text: 'No sabes cómo llevar la filosofía a la clase sin sonar forzada'
}, {
  emoji: '💸',
  text: 'Cobras menos de lo que mereces porque no sabes cómo posicionarte'
}, {
  emoji: '😓',
  text: 'Tus alumnos siempre hacen lo mismo y tus clases no crecen'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <div className="text-center mb-12" data-id="element-103">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-104">
            👉 ¿Te reconoces en estas escenas?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-105">
            Si respondes sí a alguna — este kit es para ti
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-106">
          {points.map((point, i) => <div key={i} className="flex items-center gap-4 sm:gap-6 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light shadow-sm" data-id="element-107">
              <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-108">
                {point.emoji}
              </div>
              <p className="text-text-main font-medium text-base sm:text-lg leading-snug" data-id="element-109">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-110">
          <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold" data-id="element-111">
            Y tú mereces mucho más que eso →
          </p>
        </div>
      </div>
    </section>;
}